import { PermissionProject } from "./PermissionProject";

export interface TeamPermissionTeam {
  id: number;
  name: string;
  permissionCount: number;
}

export interface TeamPermissionItem {
  id: number;
  name: string;
  identifier: string;
  teamIds: number[];
}

export interface TeamPermissionCatalog {
  project: PermissionProject;
  teams: TeamPermissionTeam[];
  permissions: TeamPermissionItem[];
}

export interface TeamPermissionChange {
  teamId: number;
  roleId: number;
  included: boolean;
}

export function teamPermissionLabel(name: string): string {
  if (name.trim().toLowerCase() === "super admin") return "Admin";
  return name;
}

export interface TeamPermissionActivityLog {
  id: number;
  project: PermissionProject;
  teamId: number;
  roleId: number;
  action: "GRANTED" | "REVOKED";
  activity: string;
  adminId: number;
  adminName: string;
  platform: string | null;
  createdAt: string;
}

export interface TeamPermissionActivityPage {
  project: PermissionProject;
  logs: TeamPermissionActivityLog[];
  totalCount: number;
  pageNo: number;
  limit: number;
}
